import React, { Component } from "react";
import moment from "moment";
import MyPagination from "./pagination";

import styles from "./messageList.less";

export default class MessageList extends Component {
  renderItem(item, index) {
    const backgroundColor = item.checked ? "#F7F7F7" : "#fff";
    const { changeMessage } = this.props;
    return (
      <div
        className={styles.messageItem}
        key={item.id}
        style={{ backgroundColor: backgroundColor }}
        onClick={() => changeMessage(item, index)}
      >
        <p>{this.renderTitle(item.title)}</p>
        <div>
          <span>{moment(item.createTime).format("YYYY.MM.DD HH:mm")}</span>
          {item.canLeaveWords ? (
            <span>{item.leaveWordsCount}条</span>
          ) : (
            <span className={styles.cantLeave}>留言暂未开启</span>
          )}
        </div>
      </div>
    );
  }

  renderTitle = title => {
    if (title.length > 50) {
      return `${title.substring(0, 50)}...`;
    }
    return title;
  };

  render() {
    const {
      messageListData,
      messagePagination,
      getMessage,
      noData
    } = this.props;
    return (
      <div className={styles.messageList}>
        <div className="title">全部消息</div>
        {!noData && <div className="noData">暂无文章</div>}
        {(messageListData || []).map((item, index) => {
          return this.renderItem(item, index);
        })}
        {noData && (
          <div className={styles.pagination}>
            <MyPagination
              type="message"
              messagePagination={messagePagination}
              getMessage={getMessage}
            />
          </div>
        )}
      </div>
    );
  }
}
